module.exports = __webpack_public_path__ + "static/media/yun_ingrid_chuang.de3da262.jpg";